import React, { useState } from "react";
import ContextDrawer from "./ContextDrawer";
import RoomBookingDrawer from "./RoomBookingDrawer";
import DocumentsPanel from "./DocumentsPanel";
import ContactsPanel from "./ContactsPanel";
import LocalWeatherPanel from "./LocalWeatherPanel";
import LocalExplorerDrawer from "./LocalExplorerDrawer";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileLines,
  faCalendarDays,
  faAddressCard,
  faCube,
  faChartPie,
  faChevronRight,
  faUser,
  faTemperatureHigh
} from "@fortawesome/free-solid-svg-icons";




/* ===========================
   Drawer Types
=========================== */
const DRAWER_TYPE_ROOMBOOKING = "roombooking";
const DRAWER_TYPE_DRAWINGS = "drawings";
const DRAWER_TYPE_SCAN = "scan";
const DRAWER_TYPE_CONTACTS = "contacts";
const DRAWER_TYPE_LOCAL = "local";

/* ===========================
   Drawer Widths
=========================== */
const CONTEXT_DRAWER_WIDTH_SMALL = "small";
const CONTEXT_DRAWER_WIDTH_MEDIUM = "medium";
const CONTEXT_DRAWER_WIDTH_LARGE = "large";

export default function BuildingDrawer({ open, building, onClose, onOpenForge }) {

  const [menuOpen, setMenuOpen] = useState(false);
  const [contextPanel, setContextPanel] = useState(null);

  const isLocalMode = contextPanel === DRAWER_TYPE_LOCAL;

  if (!building) return null;

  /* ===========================
     Drawer width resolver
  =========================== */
  const getContextDrawerSize = () => {
    if (contextPanel === DRAWER_TYPE_ROOMBOOKING) return CONTEXT_DRAWER_WIDTH_SMALL;
    if (contextPanel === DRAWER_TYPE_DRAWINGS) return CONTEXT_DRAWER_WIDTH_LARGE;
    if (contextPanel === DRAWER_TYPE_SCAN) return CONTEXT_DRAWER_WIDTH_LARGE;
	if (contextPanel === DRAWER_TYPE_CONTACTS) return CONTEXT_DRAWER_WIDTH_LARGE;
	if (contextPanel === DRAWER_TYPE_LOCAL) return CONTEXT_DRAWER_WIDTH_LARGE;
    return CONTEXT_DRAWER_WIDTH_MEDIUM;
  };

  /* ===========================
     Styles
  =========================== */

  const drawerStyle = {
    position: "fixed",
    top: "0px",
    right: open ? "0px" : "-460px",
    width: "460px",
    height: "100vh",
    background: "#ffffff",
    boxShadow: "-6px 0 18px rgba(0,0,0,0.08), -2px 0 6px rgba(0,0,0,0.06)",
    transition: "right 0.4s ease",
    zIndex: 300,
    display: "flex",
    flexDirection: "column",
    borderLeft: "1px solid #e5e5e5",
    overflow: "hidden",
    marginLeft: "20px"
  };

  const swooshImageContainer = {
    position: "relative",
    height: "230px",
    width: "calc(100% - 20px)",
    marginLeft: "20px",
    marginTop: "16px",
    overflow: "hidden",
    borderBottomLeftRadius: "180px 120px",
    borderTopLeftRadius: "18px",
    borderTopRightRadius: "18px",
    background: "#ffffff",
    boxShadow: "0 18px 30px rgba(0,0,0,0.48)"
  };

  const swooshImage = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    filter: "brightness(0.75)"
  };

  const swooshOverlay = {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(180deg, rgba(0,0,0,0.15), rgba(0,0,0,0.55))"
  };

  const closeStyle = {
    position: "absolute",
    top: "16px",
    right: "20px",
    fontSize: "18px",
    cursor: "pointer",
    color: "white",
    zIndex: 10
  };

  const titleOverlay = {
    position: "absolute",
    bottom: "24px",
    left: "98px",
    right: "28px",
    color: "white",
    zIndex: 10
  };

  const titleStyle = {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "1.2",
    marginBottom: "4px"
  };

  const subtitleStyle = {
    fontSize: "13px",
    opacity: 0.85
  };

  const bodyStyle = {
    padding: "20px 28px",
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    flex: 1,
    overflowY: "auto"
  };

  const sectionLabel = {
    fontSize: "11px",
    color: "#999",
    marginBottom: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  };

  const sectionValue = {
    fontSize: "14px",
    fontWeight: 500,
    color: "#222"
  };

  const statsRow = {
    display: "flex",
    gap: "12px"
  };

  const statBox = {
    flex: 1,
    background: "#f6f7f9",
    borderRadius: "10px",
    padding: "12px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.04)"
  };

  const statLabel = {
    fontSize: "11px",
    color: "#777"
  };

  const statValue = {
    fontSize: "15px",
    fontWeight: 600,
    color: "#111"
  };

  const actionButton = {
    marginTop: "0px",
    width: "100%",
    padding: "14px",
    borderRadius: "10px",
    border: "none",
    background: "#f4c400",
    color: "#000",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    boxShadow: "0 6px 12px rgba(0,0,0,0.12)"
  };

  const revealRail = {
    borderLeft: "2px solid #f4c400",
    marginLeft: "6px",
    paddingLeft: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  };

  const railItem = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "11px 14px",
    borderRadius: "12px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
    color: "#333",
    transition: "all 0.22s ease",
    border: "1px solid rgba(0,0,0,0.04)",
    boxShadow: "0 2px 4px rgba(0,0,0,0.03)"
  };

  const railChevron = {
    fontSize: "14px",
    color: "#f4c400",
    width: "14px"
  };

  const railIcon = {
    fontSize: "14px",
    color: "#666",
    width: "16px"
  };

  const buildMenuItem = (label, icon, context) => (
    <div style={railItem} onClick={() => setContextPanel(context)}>
      <FontAwesomeIcon icon={faChevronRight} style={railChevron} />
      <FontAwesomeIcon icon={icon} style={railIcon} />
      <span>{label}</span>
    </div>
  );

  /* ===========================
     Render
  =========================== */

  return (
    <>
      <div style={drawerStyle}>

        {/* Header */}
        <div style={swooshImageContainer}>
          <img src={building.image} alt={building.name} style={swooshImage} />
          <div style={swooshOverlay} />
          <div style={closeStyle} onClick={onClose}>✕</div>

          <div style={titleOverlay}>
            <div style={titleStyle}>{building.name}</div>
            <div style={subtitleStyle}>{building.location}</div>
          </div>
        </div>

        {/* Body */}
        <div style={bodyStyle}>

          <div>
            <div style={sectionLabel}>Address</div>
            <div style={sectionValue}>{building.address}</div>
          </div>

          

		  {!isLocalMode && (
		    <>
			<div style={statsRow}>
			            <div style={statBox}>
			              <div style={statLabel}>Sq Ft</div>
			              <div style={statValue}>{building.areaSqFt}</div>
			            </div>
			            <div style={statBox}>
			              <div style={statLabel}>Floors</div>
			              <div style={statValue}>{building.floors}</div>
			            </div>
			          </div>

			          <div style={statsRow}>
			            <div style={statBox}>
			              <div style={statLabel}>Capacity</div>
			              <div style={statValue}>{building.capacity}</div>
			            </div>
			            <div style={statBox}>
			              <div style={statLabel}>Year Built</div>
			              <div style={statValue}>{building.yearBuilt}</div>
			            </div>
			          </div>

			          <div>
			            <div style={sectionLabel}>Description</div>
			            <div style={{ fontSize: "13px", lineHeight: "1.5", color: "#444" }}>
			              {building.description}
			            </div>
			          </div>
		      <button style={actionButton} onClick={() => setMenuOpen(!menuOpen)}>
		        Open Building Book
		      </button>

		      <div style={{
		        maxHeight: menuOpen ? "340px" : "0px",
		        overflow: "hidden",
		        transition: "max-height 0.45s ease"
		      }}>
		        {menuOpen && (
		          <div style={revealRail}>
		            {buildMenuItem("Drawings & Documents", faFileLines, DRAWER_TYPE_DRAWINGS)}
		            {buildMenuItem("Room Booking", faCalendarDays, DRAWER_TYPE_ROOMBOOKING)}
		            {buildMenuItem("Virtual Tour", faCube, DRAWER_TYPE_SCAN)}
		            {buildMenuItem("Contacts & Information", faUser, DRAWER_TYPE_CONTACTS)}
		            {buildMenuItem("Local Info & Weather", faTemperatureHigh, DRAWER_TYPE_LOCAL)}
		          </div>
		        )}
		      </div>
		    </>
		  )}
		  {isLocalMode && (
			<>
		    <LocalWeatherPanel building={building} />
			
			</>
		  )}

        </div>
      </div>

      {/* Context Drawer – untouched */}
	  <ContextDrawer
	    open={contextPanel !== null}
	    title={
	      contextPanel === DRAWER_TYPE_ROOMBOOKING
	        ? "Room Booking"
	        : contextPanel === DRAWER_TYPE_DRAWINGS
	        ? "Drawings & Documents"
	        : contextPanel === DRAWER_TYPE_SCAN
	        ? "Virtual Tour"
			: contextPanel === DRAWER_TYPE_CONTACTS
	        ? "Contacts & Places"
			: contextPanel === DRAWER_TYPE_LOCAL
			? "Local Info & Weather"
	        : ""
	    }
	    subtitle={
	      contextPanel === DRAWER_TYPE_ROOMBOOKING
	        ? "Live availability & occupancy"
	        : contextPanel === DRAWER_TYPE_DRAWINGS
	        ? "Plans, BIM & reports"
	        : contextPanel === DRAWER_TYPE_SCAN
	        ? "Immersive building walkthrough"
			: contextPanel === DRAWER_TYPE_SCAN
			? "Search for people and find your places"
			: contextPanel === DRAWER_TYPE_LOCAL
			? "Find amenities and discover the local area"
	        : ""
	    }
	    size={getContextDrawerSize()}
	    onClose={() => setContextPanel(null)}
	  >

        {contextPanel === DRAWER_TYPE_ROOMBOOKING && <RoomBookingDrawer />}
        {contextPanel === DRAWER_TYPE_DRAWINGS && <DocumentsPanel onOpenForge={onOpenForge} />}
        {contextPanel === DRAWER_TYPE_SCAN && (
          <iframe
            title="Virtual Tour"
            src="https://tour.giraffe360.com/addd9e3d5b1f47e1b82bb64c672baf16/"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        )}
		{contextPanel === DRAWER_TYPE_CONTACTS && <ContactsPanel/>}
		{contextPanel === DRAWER_TYPE_LOCAL && <LocalExplorerDrawer/>}
      </ContextDrawer>
	 
    </>
  );
}
